<template>
  <div>
     <CookieConsent />
    <NavbarPublic />
  
    <main class="pt-5"  style="padding-top: 0rem !important;">
      <router-view />
    </main>
   
   <FooterSection />
   
  </div>
</template>

<script setup>
import NavbarPublic from '../components/NavbarPublic.vue'
import FooterSection from '../components/FooterSection.vue';
import MiniFilterBar from '../components/MiniFilterBar.vue'
import CookieConsent from '../components/CookieConsent.vue'

</script>

<style scoped>
main {
  padding-top: 80px; /* чтобы контент не перекрывался navbar'ом */
}
</style>
